exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#close {\n  background-color: #F3F3F3;\n  height: 15px;\n  position: absolute;\n  width: 100%; }\n\n#close-bottom-line, #close-top-line {\n  background-color: #979797;\n  height: 2px;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 8px;\n  width: 15px; }\n\n#close-top-line {\n  top: 5px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/electraLib/component/slideBar/slideBar.component.scss
// module id = 415
// module chunks = 1